<template>
    <RouterView></RouterView>
  </template>
  <script>
  export default {
  
  }
  </script>